import React from "react";
import styles from "./FullProfile.module.css";

export default function Projects({ data }) {
  return (
    <>
      <h4>A. Thesis Supervision / Guidance </h4>

      <div className={styles.noGrid}>
        {data?.thesisSupervision?.length
          ? data?.thesisSupervision.map((item) => (
              <div key={item.title} className={styles.bookContainer}>
                <div className={styles.bookTitle}> {item.title}</div>
                <div className={styles.publishRow}>
                  <strong>Year : </strong> {item.year}
                </div>
                <div className={styles.publishRow}>
                  <strong>Level : </strong> {item.level}
                </div>
                <div className={styles.publishRow}>
                  <strong>Status : </strong> {item.status}
                </div>
              </div>
            ))
          : "No Records"}
      </div>
      <h4>B. Dissertations / Student Projects</h4>
      <div className={styles.noGrid}>
        {data?.dissertations?.length
          ? data?.dissertations.map((item) => (
              <div key={item.title} className={styles.bookContainer}>
                <div className={styles.bookTitle}> {item.title}</div>
                <div className={styles.publishRow}>
                  <strong> Year : </strong> {item.year}
                </div>
                <div className={styles.publishRow}>
                  <strong> Level : </strong> {item.level}
                </div>
                <div className={styles.publishRow}>
                  <strong> Institution : </strong> {item.institution}
                </div>
                <div className={styles.publishRow}>
                  <strong>Status : </strong>
                  {item.status}
                </div>
              </div>
            ))
          : "No Records"}
      </div>
      <h4>C. Funded Research Projects</h4>
      <div className={styles.noGrid}>
        {data?.fundedResearchProjects?.length
          ? data?.fundedResearchProjects.map((item) => (
              <div key={item.projectTitle} className={styles.bookContainer}>
                <div className={styles.bookTitle}> {item.projectTitle}</div>
                <div className={styles.publishRow}>
                  <strong> Role : </strong> {item.role}
                </div>
                <div className={styles.publishRow}>
                  <strong> Duration : </strong> {item.duration}
                </div>
                <div className={styles.publishRow}>
                  <strong> Grant Amount : </strong> {item.grantAmount}
                </div>
                <div className={styles.publishRow}>
                  <strong>Funding Agency : </strong>
                  {item.fundingAgency}
                </div>
                <div className={styles.publishRow}>
                  <strong>Status : </strong>
                  {item.status}
                </div>
              </div>
            ))
          : "No Records"}
      </div>
    </>
  );
}
